import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  BookMarked,
  Cog,
  SquareChartGantt,
  TextQuote,
  Search,
} from "lucide-react";
import TabBar from "./TabBar";
import SidePayWall from "./SidePayWall";
import Typography from "../Typography/Typography";

export default function Sidebar(props) {
  const { onUpgradeClick } = props;
  const [activeTab, setActiveTab] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const path = window.location.pathname.split("/").pop();
    const tabMap = { library: 0, research: 1, index: 2, roadmap: 3, settings: 4 };
    setActiveTab(tabMap[path] ?? null);
  }, []);

  const handleTabClick = (tabIndex, path) => {
    setActiveTab(tabIndex);
    navigate(`/client/${path}`);
  };

  const handleBorderClick = (e) => {
    console.log("check");
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:flex w-1/6 h-screen flex-col px-4 py-6 bg-gray-100 justify-between relative">
        <div className="flex flex-col gap-6">
          <img
            className="md:w-32 w-12"
            src="/assets/images/logo/lockup.svg"
            alt="Athena Logo"
          />
          <div className="flex flex-col gap-1">
            <TabBar
              icon={<BookMarked size="20" />}
              text="Libreria"
              isActive={activeTab === 0}
              onClick={() => handleTabClick(0, "library")}
            />
            <TabBar
              icon={<Search size="20" />}
              text="Ricerca"
              isActive={activeTab === 1}
              onClick={() => handleTabClick(1, "research")}
            />
            <TabBar
              icon={<TextQuote size="20" />}
              text="Indice"
              isActive={activeTab === 2}
              onClick={() => handleTabClick(2, "index")}
            />
            <TabBar
              icon={<SquareChartGantt size="20" />}
              text="Roadmap"
              isActive={activeTab === 3}
              onClick={() => handleTabClick(3, "roadmap")}
            />
          </div>
        </div>
        <div className="flex flex-col gap-6">
          <SidePayWall onClick={onUpgradeClick} />
          <TabBar
            icon={<Cog size="20" />}
            text="Impostazioni"
            isActive={activeTab === 4}
            onClick={() => handleTabClick(4, "settings")}
          />
        </div>
        <div
          className="absolute inset-y-0 right-0 w-[2px] bg-gray-150 cursor-col-resize"
          onClick={handleBorderClick}
        />
      </div>

      {/* Mobile Bottom Navigation */}
      <div ref={props.ref} className="z-50 fixed bottom-0 w-full bg-gray-100 px-9 py-4 flex justify-around gap-9 md:hidden border-t-2 border-gray-150 pointer-events-auto">
        <button
          onClick={() => handleTabClick(0, "library")}
          className={`${activeTab === 0 ? "text-black" : "text-gray-600"}`}
        >
          <div className="flex flex-col items-center gap-2">
            <BookMarked size="20" />
            <Typography
              weight="md"
              size="12"
              color={`${activeTab === 0 ? "black" : "gray-600"}`}
            >
              Libreria
            </Typography>
          </div>
        </button>
        <button
          onClick={() => handleTabClick(1, "research")}
          className={`${activeTab === 1 ? "text-black" : "text-gray-600"}`}
        >
          <div className="flex flex-col items-center gap-2">
            <Search size="20" />
            <Typography
              weight="md"
              size="12"
              color={`${activeTab === 1 ? "black" : "gray-600"}`}
            >
              Ricerca
            </Typography>
          </div>
        </button>
        <button
          onClick={() => handleTabClick(2, "index")}
          className={`${activeTab === 2 ? "text-black" : "text-gray-600"}`}
        >
          <div className="flex flex-col items-center gap-2">
            <TextQuote size="24" />
            <Typography
              weight="md"
              size="12"
              color={`${activeTab === 2 ? "black" : "gray-600"}`}
            >
              Indice
            </Typography>
          </div>
        </button>
        <button
          onClick={() => handleTabClick(3, "roadmap")}
          className={`${activeTab === 3 ? "text-black" : "text-gray-600"}`}
        >
          <div className="flex flex-col items-center gap-2">
            <SquareChartGantt size="24" />
            <Typography
              weight="md"
              size="12"
              color={`${activeTab === 3 ? "black" : "gray-600"}`}
            >
              Roadmap
            </Typography>
          </div>
        </button>
      </div>
    </>
  );
}
